/**
 * Адреса «Эфиров» и старые ссылки на эфиры внутри «Моих лекций».
 *
 * Эфиры жили на «Моих лекциях»: полоса над вкладками, вкладка `?tab=streams`,
 * открытый эфир `?stream=<id>`, тестовый вход `?liveTest=<id>` и ссылка
 * доступа `?token=` (её копировал пульт эфира на site_server). Теперь у них своя
 * страница, пока только для администраторов (владелец, 11.10). Старые ссылки:
 * администратору — на «Эфиры» с тем же эфиром, остальным — на «Мои лекции» без
 * эфирных параметров.
 *
 * Ссылки «поделиться эфиром» больше нет (владелец, 11.10: «не надо ссылку
 * поделиться эфиром»): пульт её не выдаёт, сервер `?token=` не принимает.
 * Старая ссылка с токеном уводит туда же, куда и прочие, а сам токен по
 * дороге отбрасывается — он ничего не открывает.
 */

/** Адрес страницы «Эфиры» (без языка). */
export const STREAMS_PATH = "/account/streams";
/** Адрес «Моих лекций» (без языка). */
export const LECTURES_PATH = "/account/lectures";

/** Параметры адреса «Моих лекций», которые были про эфиры (кроме `tab=streams`). */
export const STREAM_PARAMS = ["stream", "liveTest", "token"] as const;

/** Параметры старых ссылок, которые не значат больше ничего и не доезжают никуда. */
const DEAD_PARAMS = ["token"] as const;

const query = (sp: URLSearchParams): string => {
    const q = sp.toString();
    return q ? `?${q}` : "";
};

/** Адрес «Моих лекций» — старая ссылка на эфиры? */
export const isOldStreamsLink = (search: string): boolean => {
    const sp = new URLSearchParams(search);
    return sp.get("tab") === "streams" || STREAM_PARAMS.some((k) => sp.has(k));
};

/**
 * Куда ведёт старая ссылка на эфиры: администратору — «Эфиры» (вкладки
 * «Моих лекций» там нет, эфир — тот же, токен ссылки отброшен), остальным —
 * «Мои лекции» без эфирных параметров. Прочие параметры (`source=app` и т. п.)
 * доезжают.
 */
export const oldStreamsLinkTarget = (lang: string, search: string, admin: boolean): string => {
    const sp = new URLSearchParams(search);
    if (admin) {
        sp.delete("tab");
        for (const k of DEAD_PARAMS) sp.delete(k);
        return `/${lang}${STREAMS_PATH}${query(sp)}`;
    }
    if (sp.get("tab") === "streams") sp.delete("tab");
    for (const k of STREAM_PARAMS) sp.delete(k);
    return `/${lang}${LECTURES_PATH}${query(sp)}`;
};

/** «Эфиры» не администратору — «Мои лекции» (эфирные параметры не доезжают). */
export const streamsFallbackTarget = (lang: string, search: string): string => {
    const sp = new URLSearchParams(search);
    for (const k of STREAM_PARAMS) sp.delete(k);
    return `/${lang}${LECTURES_PATH}${query(sp)}`;
};
